"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
exports.Page = {
    OfferPage: "/offer",
    OffersPage: "/offers",
    LeaderboardPage: "/leaderboard",
    WaitingPurchasePage: "/waiting-purchase",
    PaymentSuccessPage: "/payment-success",
    PaymentFailedPage: "/payment-failed",
    TicketPage: "/ticket",
    LineCallbackPage: "/auth/line/callback"
};
